const KEY = "rivets:nextPath";

/** Ephemeral "where to go after auth" — sessionStorage instead of a `?next=`
 * query param, so every in-app Link/navigate stays a plain path (TanStack
 * Router's typed `to` is happiest without embedded query strings). */
export function setNextPath(path: string) {
  sessionStorage.setItem(KEY, path);
}

export function peekNextPath(): string | null {
  return sessionStorage.getItem(KEY);
}

export function consumeNextPath(): string | null {
  const path = sessionStorage.getItem(KEY);
  if (path) sessionStorage.removeItem(KEY);
  return path;
}
